'use client';

import ErrorPage, { errorTemplates } from '@sbt-web/errors-page';
import '@sbt-web/errors-page/dist/index.css';

const FourOhFour = () => {
  const { title, image, description } = errorTemplates['404'];

  return <ErrorPage title={title} image={image} description={description} />;
};

export default FourOhFour;
